module.exports = __webpack_public_path__ + "static/media/support.dd1410d7.svg";